import './TicketProcessBuy.scss';
import Button from "react-bootstrap/Button";
import React, {useEffect} from "react";
import InputGroup from 'react-bootstrap/InputGroup';
import Form from "react-bootstrap/Form";
import DatePicker from "react-datepicker";
import {Badge, ButtonGroup, Modal} from "react-bootstrap";

import {DateRange} from 'react-date-range';
import {addDays, addMonths, addYears, subYears, format, parse, parseISO, isAfter} from 'date-fns';

import {it} from "date-fns/locale";

import 'react-date-range/dist/styles.css'; // main css file
import 'react-date-range/dist/theme/default.css';
import Alert from "react-bootstrap/Alert";
import {toast} from "react-toastify";
import LoginComponent from "../Profile/LoginComponent";
import RegisterComponent from "../Profile/RegisterComponent";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faPaypal} from "@fortawesome/free-brands-svg-icons";
import {faCartPlus, faCreditCard} from "@fortawesome/free-solid-svg-icons";

const TicketProcessBuy = ({ticket, listPackages = [], withAdvantages = false}) => {

    console.log("ticket")
    console.log(ticket)
    const [user, setUser] = React.useState(null);
    const [showModalCoupon, setShowModalCoupon] = React.useState(false);
    const [showModalLogin, setShowModalLogin] = React.useState(false);
    const [showModalRegister, setShowModalRegister] = React.useState(false);
    const [isLoadingPayment, setLoadingPayment] = React.useState(false);
    const [couponUsed, setCouponUsed] = React.useState(null);
    const [forwardEmail, setEmailForward] = React.useState("");

    const [shareTicket, setShareTicket] = React.useState(false);
    const [step, setStep] = React.useState("quantity");
    const [quantity, setQuantity] = React.useState(1);
    const [index, setIndex] = React.useState(1);
    const [cart, setCart] = React.useState([]);
    const [packagesAdded, setPackagesAdded] = React.useState([]);
    const [currentTicket, setCurrentTicket] = React.useState({
        date_start: "",
        date_end: "",
        nickname: "",
        extra_data: []
    });

    const [dateCalendar, setDateCalendar] = React.useState([
        {
            startDate: null,
            endDate: new Date(""),
            key: 'selection',
            color: "rgb(81, 178, 112)"
        }
    ]);
    useEffect(() => {
        if (withAdvantages) {
            for (let pack of listPackages) {
                if (pack.type === "PREMIUM") {
                    setPackagesAdded([pack]);
                    break;
                }
            }
        }
    }, [withAdvantages]);

    useEffect(() => {
        global.permission().then((user) => {
            setUser(user);
        }).catch(error => {
        });
    }, []);

    const nextStep = () => {
        if (step === "quantity") {
            setStep("setDate");
            setIndex(1);
            setCurrentTicket({date_start: "", date_end: "", nickname: "", extra_data: [], card_fipsas: ""});
        } else {
            if (step === "setDate") {
                setStep("setNickname");
            }
            if (step === "setNickname") {
                if (ticket.area.check_fipsas_enabled) {
                    setStep("fipsas");
                    return;
                }
                if (Object.keys(ticket.extra_data).length > 0) {
                    setStep("setExtraData");
                } else {
                    cart.push(currentTicket);
                    setCart(cart);
                    if (index < quantity) {
                        setStep("setDate");
                        setIndex(index + 1);
                        setCurrentTicket({date_start: "", date_end: "", nickname: "", extra_data: [], card_fipsas: ""});
                        setDateCalendar([
                            {
                                startDate: null,
                                endDate: new Date(""),
                                key: 'selection',
                                color: "rgb(81, 178, 112)"
                            }
                        ]);
                    } else {
                        if (Object.keys(listPackages).length > 0)
                            setStep("packages");
                        else
                            setStep("summary");
                    }
                }
            }
            if (step === "fipsas") {
                if (Object.keys(ticket.extra_data).length > 0) {
                    setStep("setExtraData");
                } else {
                    cart.push(currentTicket);
                    setCart(cart);
                    if (index < quantity) {
                        setStep("setDate");
                        setIndex(index + 1);
                        setCurrentTicket({date_start: "", date_end: "", nickname: "", extra_data: [], card_fipsas: ""});
                        setDateCalendar([
                            {
                                startDate: null,
                                endDate: new Date(""),
                                key: 'selection',
                                color: "rgb(81, 178, 112)"
                            }
                        ]);
                    } else {
                        if (Object.keys(listPackages).length > 0)
                            setStep("packages");
                        else
                            setStep("summary");
                    }
                }
            }
            if (step === "packages") {
                setStep("summary");
            }
            if (step === "setExtraData") {
                cart.push(currentTicket);
                setCart(cart);
                if (index < quantity) {
                    setStep("setDate");
                    setIndex(index + 1);
                    setCurrentTicket({date_start: "", date_end: "", nickname: "", extra_data: [], card_fipsas: ""});
                    setDateCalendar([
                        {
                            startDate: null,
                            endDate: new Date(""),
                            key: 'selection',
                            color: "rgb(81, 178, 112)"
                        }
                    ]);
                } else {
                    if (Object.keys(listPackages).length > 0)
                        setStep("packages");
                    else
                        setStep("summary");
                }
            }
        }
    }

    const backStep = () => {
        if (step === "packages") {
            if (Object.keys(ticket.extra_data).length > 0)
                setStep("setExtraData");
            else
                setStep("setNickname");
        }
        if (step === "summary") {
            setIndex(Object.keys(cart).length);
            setCurrentTicket(cart[Object.keys(cart).length - 1]);
            if (Object.keys(listPackages).length > 0)
                setStep("packages");
            else if (Object.keys(ticket.extra_data).length > 0)
                setStep("setExtraData");
            else {
                if (ticket.area.check_fipsas_enabled)
                    setStep("fipsas");
                else
                    setStep("setNickname");
            }
        }

        if (step === "fipsas") {
            setStep("setNickname");
            return;
        }

        if (step === "setDate" && index === 1) {
            setStep("quantity");
            setCurrentTicket({date_start: "", date_end: "", nickname: "", extra_data: []});
        } else {
            if (step === "setNickname") {
                setStep("setDate");
                setCurrentTicket({...currentTicket, nickname: ""});
                setDateCalendar([
                    {
                        startDate: null,
                        endDate: new Date(""),
                        key: 'selection',
                        color: "rgb(81, 178, 112)"
                    }
                ]);
            }
            if (step === "setDate") {
                setIndex(index - 1);
                setCurrentTicket(cart[index - 1]);
                if (Object.keys(ticket.extra_data).length > 0) {
                    setStep("setExtraData");
                } else {
                    if (ticket.area.check_fipsas_enabled)
                        setStep("fipsas");
                    else
                        setStep("setNickname");
                }
            }
            if (step === "setExtraData") {
                if (ticket.area.check_fipsas_enabled)
                    setStep("fipsas");
                else
                    setStep("setNickname");
            }

        }
    }


    function handleSelectDate(date) {
        let save = {
            startDate: date.selection.startDate,
            endDate: getDateEnd(ticket, date.selection.startDate),
            key: 'selection',
            color: "rgb(81, 178, 112)"
        }
        setDateCalendar([save]);
        setCurrentTicket({
            ...currentTicket,
            date_start: format(date.selection.startDate, "dd/MM/yyyy"),
            date_end: format(date.selection.endDate, "dd/MM/yyyy")
        });
    }

    function handleChangeExtraData(id, value) {
        let extra_data = currentTicket.extra_data;
        let found = false;
        for (let i in extra_data) {
            if (extra_data[i].id === id) {
                extra_data[i].value = value;
                found = true;
            }
        }
        if (!found)
            extra_data.push({id: id, value: value});
        setCurrentTicket({...currentTicket, extra_data: extra_data});
    }

    function setQuantityTicket(number) {
        if (number <= 0 || isNaN(number) || number > 20) {
            toast.warning("Non puoi impostare questo valore");
            return;
        }
        setQuantity(number);
    }

    function getTotalPackages() {
        let total = 0;
        for (let pack of packagesAdded) {
            if (pack.type === "PREMIUM")
                continue;
            let price = pack.discounted_price !== null ? pack.discounted_price : pack.price;
            if (!pack.is_price_for_all)
                price *= quantity;
            total += price;
        }
        return total;
    }

    function addPackage(pack) {
        const found = packagesAdded.find(item => item.id === pack.id);
        if (!found)
            setPackagesAdded([...packagesAdded, pack]);

    }

    function removePackage(pack) {
        const found = packagesAdded.find(item => item.id === pack.id);
        if (found) {
            const updatedPackages = packagesAdded.filter(item => item.id !== pack.id);
            setPackagesAdded(updatedPackages);
        }
    }

    function getPackages() {
        let result = [];

        for (let pack of listPackages) {
            const found = packagesAdded.find(item => item.id === pack.id);

            result.push(<div className={"item"}>
                <div>
                    <img src={global.baseUrl + pack.image} alt=""/>
                </div>
                <div className={"item-description"}>
                    <b className={"orange"}>{pack.name}</b>
                    <p className={"description"}>{pack.description}</p>
                    <span className={"price"}>{pack.price}€</span>
                    <div className={"d-flex "}>
                        {found ? <Button variant={"light"} style={{fontSize: 14}} onClick={() => removePackage(pack)}>
                                <FontAwesomeIcon icon={faCartPlus} color={"#198754"} style={{marginRight: 6}} size={"sm"}/>Rimuovi
                                dal carrello</Button> :
                            <Button variant={"success"} style={{fontSize: 14}} onClick={() => addPackage(pack)}>
                                <FontAwesomeIcon icon={faCartPlus} color={"#fafafa"} style={{marginRight: 6}}
                                                 size={"sm"}/>Aggiungi
                                al carrello</Button>}
                    </div>
                </div>
            </div>);
        }
        return result;
    }

    function checkFipsas() {
        fetch(global.route.checkFipsas, {
            method: "post",
            credentials: 'include',
            body: global.getFormData({number_card: currentTicket.card_fipsas})
        })
            .then(response => {
                if (response.status !== 200) {
                    toast.error("Impossibile controllare il numero di tesserino");
                } else {
                    response.json().then(response => {
                        if (typeof response.fipsas !== "undefined") {
                            if (response.fipsas === null) {
                                toast.error("Tessera non valida")
                            } else {
                                if (typeof response.fipsas.dataScadenzaTessera !== "undefined") {
                                    let date = parseISO(response.fipsas.dataScadenzaTessera);
                                    if (isAfter(new Date(), date)) {
                                        toast.error("Tessera scaduta")
                                    } else {
                                        nextStep();
                                    }
                                } else
                                    nextStep();

                            }
                        }
                    });
                }
            });
    }

    const getContent = () => {
        let content = [];
        switch (step) {
            case "quantity":
                content.push(<div className={"step-quantity"}>
                    <h4>Quanti ticket vuoi acquistare?</h4>
                    <hr/>
                    <InputGroup className="mb-3">
                        <Button variant="danger" onClick={() => setQuantityTicket(quantity - 1)}>
                            Rimuovi
                        </Button>
                        <Form.Control
                            aria-label="Quantità"
                            aria-describedby="basic-addon1"
                            placeholder="Quantità"
                            type="number"
                            value={quantity}
                            onChange={(e) => setQuantityTicket(e.target.value)}
                        />
                        <Button variant="success" onClick={() => setQuantityTicket(quantity + 1)}>
                            Aggiungi
                        </Button>
                    </InputGroup>
                    <div className="d-flex justify-content-center">
                        <Button variant="success" onClick={() => nextStep()}>
                            Conferma
                        </Button>
                    </div>
                </div>);
                break;
            case "setDate":
                let date_start = dateCalendar[0].startDate;

                let date_content = <div className={"mt-3"}></div>;
                if (date_start !== null) {
                    if (date_start === dateCalendar[0].endDate) {
                        date_content = <p>Il ticket sarà valido il giorno <Badge
                            bg="success">{format(date_start, "dd/MM/yyyy")}</Badge></p>;
                    } else {
                        date_content = <p>La validità del ticket partirà dal giorno <Badge
                            bg="success">{format(date_start, "dd/MM/yyyy")}</Badge> al <Badge
                            bg="success">{format(dateCalendar[0].endDate, "dd/MM/yyyy")}</Badge></p>
                    }
                }
                let min_date = parse(ticket.date_start_validity, "dd/MM/yyyy", new Date());

                if (new Date() > min_date)
                    min_date = new Date();
                let max_date = parse(ticket.date_end_validity, "dd/MM/yyyy", new Date());
                content.push(<div className={"step-date"}>
                    <Badge bg={"dark"} className={"ticket-number"}>Ticket n°{index}</Badge>
                    <hr/>
                    <h4>Per quando ti serve il ticket?</h4>
                    <div className="d-flex justify-content-center">
                        <DateRange
                            locale={it} // Assicurati di passare la lingua
                            moveRangeOnFirstSelection={false}
                            minDate={min_date}
                            maxDate={max_date}
                            ranges={dateCalendar}
                            // ranges={state.length > 0 ? state : undefined}
                            // onChange={item => setState([item.selection])}
                            onChange={handleSelectDate}
                        />
                    </div>
                    <div className="d-flex justify-content-center">
                        {date_content}
                    </div>

                    <div className="d-flex justify-content-center">
                        <ButtonGroup aria-label="Basic example">
                            <Button variant="light" onClick={() => backStep()}>
                                Indietro
                            </Button>
                            <Button variant="success" onClick={() => nextStep()} disabled={date_start === null}>
                                Continua
                            </Button>
                        </ButtonGroup>
                    </div>
                </div>);

                break;
            case "setNickname":
                content.push(<div className={"step-date"}>
                    <Badge bg={"dark"} className={"ticket-number"}>Ticket n°{index}</Badge>
                    <h4>Imposta il nominativo per questo ticket</h4>
                    <hr/>
                    <Form>
                        <Form.Group className="mb-3" controlId={"nickname"+index}>
                            <Form.Label>Nominativo sul ticket</Form.Label>
                            <Form.Control type="text" placeholder="Nominativo" defaultValue={currentTicket.nickname}
                                          key={"nickname"+index}
                                          onChange={(e) => {
                                              setCurrentTicket({...currentTicket, nickname: e.target.value});

                                          }}/>
                        </Form.Group>
                    </Form>
                    <div className="d-flex justify-content-center">
                        <ButtonGroup>
                            <Button variant="light" onClick={() => backStep()}>
                                Indietro
                            </Button>
                            <Button variant="success" onClick={() => nextStep()}
                                    disabled={currentTicket.nickname.trim() === "" ? "disabled" : ""}>
                                Continua
                            </Button>
                        </ButtonGroup>
                    </div>
                </div>);

                break;
            case "fipsas":
                content.push(<div className={"step-date"}>
                    <Badge bg={"dark"} className={"ticket-number"}>Ticket n°{index}</Badge>
                    <h4>Area sottoposta al controllo FIPSAS</h4>
                    <hr/>
                    <Form>
                        <Form.Group className="mb-3" controlId={"card_fipsas"+index}>
                            <Form.Label>Numero Tessera/Cedolino FIPSAS</Form.Label>
                            <Form.Control type="text" placeholder="Numero tessera"
                                          defaultValue={currentTicket.card_fipsas} key={"card_fipsas"+index}
                                          onChange={(e) => {
                                              setCurrentTicket({...currentTicket, card_fipsas: e.target.value});
                                          }}/>
                        </Form.Group>
                    </Form>
                    <div className="d-flex justify-content-center">
                        <ButtonGroup >
                            <Button variant="light" onClick={() => backStep()}>
                                Indietro
                            </Button>
                            <Button variant="success" onClick={() => checkFipsas()}
                                    disabled={currentTicket.card_fipsas.trim() === "" ? "disabled" : ""}>
                                Continua
                            </Button>
                        </ButtonGroup>
                    </div>
                </div>);

                break;
            case "setExtraData":
                let extraDataContent = [];
                let can_continue = true;
                for (let data of ticket.extra_data) {
                    let currentValue = null;
                    if (currentTicket.extra_data.find((item) => item.id === data.id) !== undefined) {
                        currentValue = currentTicket.extra_data.find((item) => item.id === data.id).value;
                    }
                    if (data.is_required && (currentValue === null || currentValue.trim() === "")) {
                        can_continue = false;
                    }

                    let required_text = data.is_required ? <></> : <small>(non obbligatorio)</small>;
                    switch (data.type) {
                        case "DATE":
                            extraDataContent.push(
                                <Form.Group className="mb-3">
                                    <Form.Label>{data.name} {required_text}</Form.Label><br/>
                                    <DatePicker className="form-control"
                                                onChange={(date) => handleChangeExtraData(data.id, format(date, "dd/MM/yyyy"))}
                                                placeholderText={data.name}
                                                id={`extra-${data.id}`}
                                                value={currentValue}
                                    />
                                </Form.Group>
                            );
                            break;

                        case "STRING":
                            extraDataContent.push(
                                <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                                    <Form.Label>{data.name} {required_text}</Form.Label>
                                    <Form.Control type="text" placeholder={data.name} value={currentValue}
                                                  id={`extra-${data.id}`}
                                                  onChange={(e) => {
                                                      handleChangeExtraData(data.id, e.target.value)
                                                  }}/>
                                </Form.Group>
                            )
                            break;

                        case "CHECKBOX":
                            extraDataContent.push(
                                <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                                    <Form.Label>{data.name} {required_text}</Form.Label>
                                    <Form.Check // prettier-ignore
                                        type={"checkbox"}
                                        id={`extra-${data.id}`}
                                        label={data.name}
                                        onChange={(e) => {
                                            handleChangeExtraData(data.id, e.target.value)
                                        }}
                                    />
                                </Form.Group>
                            )
                            break;

                        case "SELECT":
                            extraDataContent.push(
                                <select className="form-select custom-select"
                                        id={`extra-${data.id}`}
                                        onChange={e => {
                                            handleChangeExtraData(data.id, e.target.value)
                                        }}>
                                    <option selected value={""}>Seleziona valore</option>
                                    {data.options.map((option) => (
                                        <option value={option}>{option}</option>))}
                                </select>
                            )
                            break;
                    }
                    if (typeof data.link !== "undefined" && data.link !== null)
                        extraDataContent.push(<a href={data.link}>{data.link}</a>);

                }


                content.push(<div className={"step-summary"}>
                    <h4>Campi aggiuntivi</h4>
                    <hr/>
                    {extraDataContent}
                    <div className="d-flex justify-content-center">
                        <ButtonGroup aria-label="Basic example">
                            <Button variant="light" onClick={() => backStep()}>
                                Indietro
                            </Button>
                            <Button variant="success" onClick={() => nextStep()}
                                    disabled={!can_continue ? "disabled" : ""}>
                                Continua
                            </Button>
                        </ButtonGroup>
                    </div>
                </div>);

                break;

            case "packages":
                content.push(<div className={"step-packages"}>
                    <h4>Spesso comprati insieme</h4>
                    <hr/>
                    {getPackages()}
                    <div className="d-flex justify-content-center">
                        <ButtonGroup aria-label="Basic example">
                            <Button variant="light" onClick={() => backStep()}>
                                Indietro
                            </Button>
                            <Button variant="success" onClick={() => nextStep()}>
                                Continua
                            </Button>
                        </ButtonGroup>
                    </div>
                </div>)
                break;
            case "summary":
                let rows = [];
                let summary = [];

                let button_payment = [];
                if (user === null) {
                    button_payment =
                        <div className={"text-center mb-2"}>Per completare il pagamento devi effettuare<br/> il <Button
                            className={"btn-orange"}
                            onClick={() => setShowModalLogin(true)}>login</Button> oppure <Button
                            className={"btn-orange"} onClick={() => setShowModalRegister(true)}>registrati</Button>
                        </div>
                } else {
                    if (ticket.price === 0) {
                        button_payment.push(<Button variant="success" className={"m-2"} onClick={() => checkout("cash")}
                                                    disabled={isLoadingPayment}>
                            Paga
                        </Button>);
                    } else {
                        button_payment.push(<Button variant="success" className={"m-2"}
                                                    onClick={() => checkout("paypal")} disabled={isLoadingPayment}>
                            <FontAwesomeIcon icon={faPaypal} style={{marginRight: 4}} size={"sm"}/>Paga con PayPal
                        </Button>);
                        button_payment.push(<Button variant="success" className={"m-2"}
                                                    onClick={() => checkout("stripe")} disabled={isLoadingPayment}>
                            <FontAwesomeIcon icon={faCreditCard} style={{marginRight: 4}} size={"sm"}/>Paga con Carta
                        </Button>);
                    }
                }

                if (Object.keys(cart).length === 0) {
                    rows.push(<Alert variant="warning">Non ci sono ticket nel carrello</Alert>)
                } else {
                    for (let obj of cart) {
                        rows.push(
                            <div key={obj.id} className={"summary-ticket"}>
                                <Badge bg={"success"}>Ticket n°{cart.indexOf(obj) + 1}</Badge>
                                <span>Nominativo: <b>{obj.nickname}</b></span>
                                <span>Data inizio del ticket: <b>{obj.date_start}</b></span>
                                <span>Data fine del ticket: <b>{obj.date_start}</b></span>
                            </div>
                        )
                    }
                    let total_tickets = (ticket.price * Object.keys(cart).length);
                    let total_commissions = ticket.service_fee;
                    if (total_commissions !== null && ticket.multipliable_service_fee)
                        total_commissions = ticket.service_fee * Object.keys(cart).length;


                    let total = total_tickets + total_commissions;
                    let total_discount = [];
                    if (couponUsed !== null) {
                        if (couponUsed.discount_price !== null) {
                            total -= couponUsed.discount_price;
                            total_discount = <span>Sconto: <b>-{couponUsed.discount_price}€</b></span>
                        } else {
                            let discount = ticket.price / 100 * couponUsed.discount_percentage * quantity;
                            total -= discount;
                            total_discount = <span>Sconto: <b>-{discount.toFixed(2)}€</b></span>
                        }
                    }
                    let total_packages = [];
                    let totalPackages = getTotalPackages();
                    if (totalPackages > 0) {
                        total += totalPackages;
                        total_packages = <span>Totale pacchetti: <b>{totalPackages.toFixed(2)}€</b></span>

                    }
                    summary = <div className="summary-ticket">
                        <span>Totale ticket: <b>{total_tickets.toFixed(2)}€</b></span>
                        {total_commissions !== null ?
                            <span>Commissione di servizio: <b>{total_commissions.toFixed(2)}€</b></span>
                            : <></>}
                        {total_packages}
                        {total_discount}
                        <span>Totale: <b>{(total).toFixed(2)}€</b></span>
                        <a onClick={() => setShowModalCoupon(true)}><small>Hai un codice sconto? Clicca qui per
                            applicarlo</small></a>
                        {!shareTicket ?
                            <div className="d-flex justify-content-center">
                                <span className={"orange"}
                                      onClick={() => setShareTicket(true)}>Condividi permesso</span>
                            </div> : <></>}
                        {shareTicket ? <div style={{width: "100%"}}>
                            <Form.Group className="mb-2 mt-2" controlId="coupon">
                                <Form.Label>Inoltra il permesso via email</Form.Label>
                                <Form.Control type="email" placeholder="Inserisci l'email"
                                              onChange={(e) => setEmailForward(e.target.value)}/>
                            </Form.Group>
                        </div> : <></>}
                    </div>
                }

                content.push(<div className={"step-summary"}>
                    <h4>Riepilogo ordine</h4>
                    <hr/>
                    {rows}
                    {summary}
                    <div className="d-flex justify-content-center">
                        {button_payment}
                    </div>
                    <div className="d-flex justify-content-center">
                        <Button variant="light" className={"mt-1"} onClick={() => backStep()}>
                            Indietro
                        </Button>
                    </div>

                </div>)
                break;
        }
        return content;
    }

    let callbackLogin = (user) => {
        setUser(user);
        setShowModalLogin(false);
        setShowModalRegister(false);
    }

    let checkout = (type_payment) => {
        setLoadingPayment(true);
        let data = {
            id_ticket: ticket.id,
            type_payment: "payment_" + type_payment,
            quantity: quantity,
            arr_order: JSON.stringify(cart),
            arr_packages: JSON.stringify(packagesAdded),
            source: "webapp",
            // forward_phone: this.state.forwardPhone,
            forward_email: forwardEmail
        };
        if (couponUsed !== null)
            data.coupon = couponUsed.code;
        const referral = localStorage.getItem('refid');

        if (referral !== null)
            data.referral = referral;

        fetch(global.route.ticketBuy, {
            method: "post",
            credentials: 'include',
            body: global.getFormData(data)
        })
            .then(response => {
                if (response.status !== 200) {
                    global.catchError(response);
                    setLoadingPayment(false);
                } else {
                    response.json().then(response => {
                        if (type_payment === "paypal" || type_payment === "stripe") {
                            if (response.url !== undefined)
                                window.location.href = response.url;
                        } else if (type_payment === "cash") {

                        }
                        setLoadingPayment(false);
                    });
                }
            });
    }

    let checkCoupon = (e) => {
        e.preventDefault();
        const code = e.target.elements.coupon.value;
        if (code.trim() === "") {
            toast.warning("Inserisci il codice sconto");
            return;
        }

        fetch(global.route.couponInfo, {
            method: "post",
            credentials: 'include',
            body: global.getFormData({id_ticket: ticket.id, code: code})
        })
            .then(response => {
                response.json().then(res => {
                    if (response.status !== 200) {
                        if (typeof res.error !== "undefined") {
                            toast.error("Errore " + res.error)
                        } else {
                            global.catchError(response);

                        }
                    } else {
                        setCouponUsed(res.coupon);
                        setShowModalCoupon(false);
                    }

                });
            });
    }

    return (
        <div className="ticket-buy-container">
            {getContent()}
            <Modal show={showModalCoupon} centered onHide={() => {
                setShowModalCoupon(false)
            }}>
                <Modal.Header closeButton/>
                <Modal.Body>
                    <Form onSubmit={checkCoupon}>
                        <Form.Group className="mb-3" controlId="coupon">
                            <Form.Label>Codice sconto</Form.Label>
                            <Form.Control type="text" placeholder="Inserisci il codice"/>
                        </Form.Group>
                        <Button className={"btn-orange mt-1"} type={"submit"}>Applica</Button>
                    </Form>
                </Modal.Body>
            </Modal>
            <Modal show={showModalLogin} centered onHide={() => {
                setShowModalLogin(false)
            }}>
                <Modal.Header closeButton/>
                <Modal.Body>
                    <LoginComponent onLogin={callbackLogin}/>
                </Modal.Body>
            </Modal>
            <Modal show={showModalRegister} centered onHide={() => {
                setShowModalRegister(false)
            }}>
                <Modal.Header closeButton/>
                <Modal.Body>
                    <RegisterComponent onLogin={callbackLogin}/>
                </Modal.Body>
            </Modal>
        </div>
    );
};

function getDateEnd(ticket, date) {
    let date_end = date;
    switch (ticket.type) {
        case "HOURLY":
            /*            setDataDatePicker((prev) => ({
                            ...prev,
                            includeTimes: formatCalendarIncludedTimes(
                                dataDatePicker.calendar,
                                date,
                                'open'
                            ),
                            startDate: isBefore(new Date(), date) === true ? null : date,
                            endDate: addMinutes(date, timeIntervals)
                        }));*/
            return;
        // case "DAILY":
        // setDataDatePicker((prev) => ({ ...prev, startDate: date, endDate: date }));
        // return;
        case "TWODAYS":
            date_end = addDays(date, 1);
            break;
        case "THREEDAYS":
            date_end = addDays(date, 2);
            break;
        case "FOURDAYS":
            date_end = addDays(date, 3);
            break;
        case "WEEKDAYS":
            date_end = addDays(date, 4);
            break;
        case "WEEKLY":
            date_end = addDays(date, 6);
            break;
        case "TWOWEEKS":
            date_end = addDays(date, 13);
            break;
        case "MONTHLY":
            date_end = addMonths(date, 1);
            break;
        case "TRIMESTER":
            date_end = addMonths(date, 2);
            break;
        case "SEASONAL":
        case "SEMIANNUAL":
            date_end = addMonths(date, 6);
            break;
        case "YEARLY":
            date_end = addYears(date, 1);
            break;
        case "BIANNUAL":
            date_end = subYears(date, 2);
            break;
        case "TRIENNIAL":
            date_end = addYears(date, 3);
            break;
    }
    if (date_end > parse(ticket.date_end_validity, "dd/MM/yyyy", new Date()))
        date_end = parse(ticket.date_end_validity, "dd/MM/yyyy", new Date());

    return date_end;
}

export default TicketProcessBuy;
